'use strict';
import * as $j_com$002eraquo$002eairstream$002eownership$002e$002dOwner from "./com.raquo.airstream.ownership.-Owner.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_ownership_OneTimeOwner(onAccessAfterKilled) {
  this.Ex = null;
  this.Ew = null;
  this.yz = false;
  this.Ew = onAccessAfterKilled;
  $j_com$002eraquo$002eairstream$002eownership$002e$002dOwner.$f_Lcom_raquo_airstream_ownership_Owner__$init$__V(this);
  this.yz = false;
}
export { $c_Lcom_raquo_airstream_ownership_OneTimeOwner as $c_Lcom_raquo_airstream_ownership_OneTimeOwner };
$p = $c_Lcom_raquo_airstream_ownership_OneTimeOwner.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_ownership_OneTimeOwner;
/** @constructor */
function $h_Lcom_raquo_airstream_ownership_OneTimeOwner() {
}
export { $h_Lcom_raquo_airstream_ownership_OneTimeOwner as $h_Lcom_raquo_airstream_ownership_OneTimeOwner };
$h_Lcom_raquo_airstream_ownership_OneTimeOwner.prototype = $p;
$p.ro = (function() {
  return this.Ex;
});
$p.Oc = (function(x$0) {
  this.Ex = x$0;
});
$p.PP = (function(subscription) {
  if (this.yz) {
    $j_com$002eraquo$002eairstream$002eownership$002e$002dOwner.$p_Lcom_raquo_airstream_ownership_Subscription__safeCleanup__V(subscription);
    this.Ew.h();
  } else {
    $j_com$002eraquo$002eairstream$002eownership$002e$002dOwner.$f_Lcom_raquo_airstream_ownership_Owner__own__Lcom_raquo_airstream_ownership_Subscription__V(this, subscription);
  }
});
$p.Px = (function() {
  $j_com$002eraquo$002eairstream$002eownership$002e$002dOwner.$f_Lcom_raquo_airstream_ownership_Owner__killSubscriptions__V(this);
  this.yz = true;
});
var $d_Lcom_raquo_airstream_ownership_OneTimeOwner = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_ownership_OneTimeOwner, "com.raquo.airstream.ownership.OneTimeOwner", ({
  h4: 1,
  cR: 1
}));
export { $d_Lcom_raquo_airstream_ownership_OneTimeOwner as $d_Lcom_raquo_airstream_ownership_OneTimeOwner };
